/* RESPONSIBLE TEAM: team-proactive-support */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file 🚀 */
/* eslint-disable @intercom/intercom/no-bare-strings */
import GraphConfiguration from 'embercom/objects/series/node/graph-configuration';
import StandardNodeComponentConfiguration from 'embercom/objects/series/node/standard-node-component-configuration';
import StandardConnectorConfiguration from 'embercom/objects/series/node/standard-connector-configuration';
import StatsConfiguration from 'embercom/objects/series/node/stats-configuration';
import {
  objectFeatures,
  objectTypes,
  objectNames,
  seriesEdgeTypes,
} from 'embercom/models/data/matching-system/matching-constants';
import { capitalize } from '@ember/string';

export default class OutboundWebhookGraphConfiguration extends GraphConfiguration {
  objectType = objectTypes['outboundWebhook'];

  constructor(seriesNode) {
    super(...arguments);

    this.componentConfig = new StandardNodeComponentConfiguration({
      icon: 'series/content/webhook',
      paywallIcon: 'series/content/paywalled-webhook',
      featureFlagsWithAccess: [objectFeatures[this.objectType]],
      objectType: this.objectType,
      title: seriesNode.get('rulesetClientData.title') || capitalize(objectNames[this.objectType]),
      statsSummaryConfigurationComponent: new StatsConfiguration({
        verb: 'sent',
        component: 'series/node/standard-stats-summary',
      }),
    });
  }

  get connectors() {
    return [
      new StandardConnectorConfiguration({
        label: 'WHEN SENT',
        edgeType: seriesEdgeTypes.primary,
      }),
    ];
  }

  get inferredTitle() {
    let previewText = this.node.contentPreviews.firstObject?.contentPreviewData?.content;
    if (previewText) {
      return `${previewText}`;
    }
    return '';
  }

  get defaultTitle() {
    return `Empty webhook`;
  }

  get primaryPredecessorLabel() {
    return `Sent '${this.title}'`;
  }

  get disableStatsPopover() {
    return true;
  }
}
